"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _styles = require("@material-ui/core/styles");
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _getFormData = _interopRequireDefault(require("Components/Forms/Functions/getFormData"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const styles = theme => ({
  dialog: {
    height: 200,
    maxWidth: 500,
    width: '100%'
  }
});
class EditProfessionalDomainModal extends _react.Component {
  state = {
    status_messages: {},
    'professional_domain[label]': undefined
  };
  componentDidUpdate(prevProps, prevState) {
    const component = this,
      props = this.props,
      state = this.state;
    if (prevProps.id !== props.id) {
      qwest.post('/professional-domain/get-all', {
        id: props.id
      }).then((xhr, response) => {
        component.setState({
          loading: false,
          'professional_domain[label]': response.professional_domains[0].label
        });
      }).catch((error, xhr, response) => {
        console.error(response?.error || response?.raw || error);
        component.setState({
          ...(0, _getErrorsFromResponse.default)({
            response: response
          })
        });
      });
    }
  }
  handleChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages[name];
    component.setState({
      [name]: value,
      error: undefined,
      status_messages: status_messages
    });
  };
  handleClose = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      "professional_domain[label]": undefined,
      info: undefined,
      error: undefined,
      warning: undefined
    });
    if (props.onClose) props.onClose();
  };
  handleOk = e => {
    const component = this,
      props = this.props,
      state = this.state;
    let professional_domain_data = new FormData();
    professional_domain_data.append('professional_domain[id]', props.id);
    professional_domain_data = (0, _getFormData.default)({
      form_data: professional_domain_data,
      pattern: 'professional_domain[',
      state: state
    });
    component.setState({
      loading: true
    });
    qwest.post('/professional-domain/update', professional_domain_data).then((xhr, response) => {
      component.setState({
        loading: false,
        'professional_domain[label]': undefined,
        info: 'Succès de modification du domaine professionnel'
      });
      this.props.onClose();
    }).catch((error, xhr, response) => {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = (0, _getFormStatus.default)(state);
    let output = /*#__PURE__*/_react.default.createElement(_Dialog.default, {
      maxWidth: "xs",
      open: props.open || false,
      "aria-labelledby": "Edition d'un domaine professionnel",
      classes: {
        paper: props.classes.dialog
      },
      onClose: props.onClose,
      disableBackdropClick: true
    }, /*#__PURE__*/_react.default.createElement(_DialogTitle.default, null, "Edition d'un domaine professionnel"), /*#__PURE__*/_react.default.createElement(_DialogContent.default, null, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['professional_domain[label]'],
      name: "professional_domain[label]",
      label: "Nom de l'activit\xE9",
      status: state.status_messages
    }), status), /*#__PURE__*/_react.default.createElement(_DialogActions.default, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
      onClick: component.handleOk,
      color: "primary"
    }, "Mettre \xE0 jour"), /*#__PURE__*/_react.default.createElement(_Button.default, {
      onClick: component.handleClose,
      color: "primary"
    }, "Annuler")));
    return output;
  }
}
var _default = exports.default = (0, _styles.withStyles)(styles)(EditProfessionalDomainModal);
